// extracted by mini-css-extract-plugin
export default {"Navbar":"NavBar_Navbar__r6Mku","active":"NavBar_active__YGIu6","scrolled":"NavBar_scrolled__f4+aq"};